export default function DownloadPdf() {
  async function handler() {
    {
      const btn = document.getElementById('btn')
      const src = btn.getAttribute('href')

      // Derive a decent filename from the URL (fallback if server doesn't send one), eg "file.pdf" from "68e58f2e57508b16dc5fd415_file.pdf"
      const fallbackName = decodeURIComponent(
        new URL(src).pathname
          .split('/')
          .pop()
          .replace(/^[^_]*_/, '') || 'FL-membership.pdf'
      )

      try {
        const res = await fetch(src, { credentials: 'omit' })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)

        // without the blob the file opens in browser tab instead of downloading in some browsers (eg Firefox)
        const blob = await res.blob() // get a Blob
        const url = URL.createObjectURL(blob) // create blob: URL

        const a = document.createElement('a')
        a.href = url
        a.download = fallbackName // filename hint
        document.body.appendChild(a)
        a.click() // initiate download
        a.remove()

        // give the download a beat, then free memory
        setTimeout(() => URL.revokeObjectURL(url), 1000)
      } catch (err) {
        console.error('Download failed:', err)
        // Fallback: just navigate to the original URL
        window.location.href = src
      }
    }
  }
  // still opens viewer in mobile safari, needs server's headers
  handler()
}
